import IconButton from '@mui/material/IconButton';
import type { IconButtonProps } from '@mui/material/IconButton';
import React from 'react';

const MUIIconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  (props, ref) => {
    return <IconButton ref={ref} {...props} />;
  },
);

export default MUIIconButton;
